import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Banner1 = () => {
  return (
    <div className={cx('commonBox')}>
      <span className={cx('desc')}>
        750여 개 기업에게 노출되는 내 프로필
        <br />
        인사담당자를 사로잡는 프로필 작성 Tip을 확인해보세요!
      </span>
    </div>
  );
};

export default Banner1;
